// @core/api/endpoints/booking/accept_waitlist_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcceptWaitlistOfferRequest,
  BookingResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Accept waitlist offer
 * Accepts a slot offer from the waitlist and creates a booking.
 */
export async function AcceptWaitlistOffer(
  entry_id: string,
  data: AcceptWaitlistOfferRequest,
  options?: RequestOptions
): Promise<BookingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/waitlist/:entry_id/accept`;
  requestPath = requestPath.replace(':entry_id', encodeURIComponent(entry_id));
  const requestOptions = options;
  return client.post<BookingResponse>(requestPath, data, requestOptions);
}
